import { render } from "./control-crosshair.vue?vue&type=template&id=d24b5790&scoped=true"
import script from "./control-crosshair.vue?vue&type=script&lang=js"
export * from "./control-crosshair.vue?vue&type=script&lang=js"

import "./control-crosshair.vue?vue&type=style&index=0&id=d24b5790&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d24b5790"]])

export default __exports__